export const FEATURE_NAME = '@zerops/zui/project-env-edit-form';
